import { AccountSettings, Button, DropZone, TextField } from "@aws-amplify/ui-react"
import { useAuthenticator } from "@aws-amplify/ui-react"
import { fetchUserAttributes, updateUserAttribute, updateUserAttributes } from "aws-amplify/auth"
import { useEffect, useState, useRef } from "react"
import { apiUploadAvatar } from "../api/api"
import { useSelector } from "react-redux"


export const UserProfilePage = ({ }) => {

    const [userName, setUserName] = useState("")
    const [originalUserName, setOriginalUserName] = useState("")
    const [userPicture, setUserPicture] = useState(null)
    const [updateInProgress, setUpdateInProgress] = useState(false)
    const [avatarSource, setAvatarSource] = useState(null)
    const hasFetched = useRef(false)
    const { user } = useAuthenticator((context) => [context.user]);
    const fetchUser = async () => {
        const userAttributes = await fetchUserAttributes();
        setUserName(userAttributes?.name)
        setOriginalUserName(userAttributes?.name)
        setUserPicture(userAttributes?.picture)
    }
    const saveChanges = async () => {
        try {
            setUpdateInProgress(true)
            if (userName !== originalUserName) {
                await updateUserAttributes({
                    userAttributes: {
                        name: userName
                    }
                })
                setOriginalUserName(userName)
            }
            if (avatarSource) {
                const result = await apiUploadAvatar(user, avatarSource);
                if (result.data?.message === "ok") {
                    await updateUserAttribute(
                        {
                            userAttributes: {
                                picture: `https://liftolog-media.s3.amazonaws.com/avatars/${user.userId}.jpg`
                            }
                        }
                    )
                    setUserPicture(`https://liftolog-media.s3.amazonaws.com/avatars/${user.userId}.jpg`)
                }
            }
        } catch (e) {
            console.log(e)
        } finally {
            setUpdateInProgress(false)
        }
    }

    const processImage = (file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            img.onload = () => {
                // Set canvas to exactly 600x600
                canvas.width = 600;
                canvas.height = 600;

                // Calculate crop area (1:1 from center)
                const size = Math.min(img.width, img.height);
                const startX = (img.width - size) / 2;
                const startY = (img.height - size) / 2;

                // Draw cropped and scaled image
                ctx.drawImage(
                    img,
                    startX, startY, size, size,  // Source crop area
                    0, 0, 600, 600               // Destination size
                );

                // Convert to data URL
                const dataUrl = canvas.toDataURL('image/jpeg', 0.9);
                resolve(dataUrl);
            };

            img.onerror = reject;
            img.src = URL.createObjectURL(file);
        });
    };

    const handleImageDrop = async (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
            try {
                const processedImage = await processImage(file);
                setAvatarSource(processedImage);
            } catch (error) {
                console.error('Image processing failed:', error);
            }
        }
    }
    const apiEnabled = useSelector(state => state.exercises?.apiEnabled)
    useEffect(() => {
        if (!hasFetched.current && apiEnabled) {
            fetchUser()
            hasFetched.current = true
        }
    }, [])

    return (<div
        className="user-profile-container mx-1"
        style={{
            textAlign: 'start'
        }}>
        <div className="my-2" style={{ maxWidth: '800px' }}>
            <section id="account-settings"></section>
            <h3>Account Settings</h3>
            <TextField
                descriptiveText="Choose a unique name that represents you. This will appear on your profile, in search results, and on all your posts."
                disabled={updateInProgress}
                placeholder="User Name"
                hasError={userName?.length === 0}
                value={userName}
                onChange={(e) => {
                    setUserName(e.target.value)
                }}
                errorMessage="Can't be empty">
            </TextField>
            <div className="small mt-2">Your picture</div>
            <div className="row">
                <div className="col-2">
                    <img className="avatar-preview" src={avatarSource ? avatarSource : userPicture} />
                </div>
                <div className="col-10">
                    <DropZone
                        acceptedFileTypes={['image/*']}
                        onDropComplete={({ acceptedFiles }) => {
                            handleImageDrop(acceptedFiles)
                        }}
                    >
                        Drag an image here
                    </DropZone>
                </div>
            </div>
            <Button
                className="w-100 mt-2"
                disabled={(originalUserName === userName && !avatarSource) || updateInProgress}
                onClick={() => {
                    saveChanges()
                }}
            >
                Save Changes
            </Button>
            <section id="change-password"></section>
            <h3 className="mt-5">Change Password</h3>
            <AccountSettings.ChangePassword></AccountSettings.ChangePassword>

            <section id="remove-personal-info" />
            <h3 className="mt-5">Delete Account</h3>
            <p>
                If you wish to delete your personal information, you can either click the "Delete Account" button below or contact us directly at liftolog@proton.me.
            </p><p>
                Based on the applicable laws of your country or state of residence in the US, you may have the right to request access to the personal information we collect from you, details about how we have processed it, correct inaccuracies, or delete your personal information. You may also have the right to withdraw your consent to our processing of your personal information. These rights may be limited in some circumstances by applicable law.
            </p>
            <AccountSettings.DeleteUser
                displayText={{
                    deleteAccountText: 'Delete the account',
                    cancelButtonText: 'Cancel',
                    confirmDeleteButtonText: 'Delete account',
                    warningText: 'Are you sure you want to delete your account? You will lose access and all data.'
                }}
                className="d-flex justify-content-center"
                onSuccess={() => {

                }}>

            </AccountSettings.DeleteUser>
            <div style={{ height: '100px' }}>

            </div>

        </div>


    </div>)
}